import { Types } from '../constants/actionTypes';

export const ActionPermissions = {

  internalUserPermissions: (userData) => ({ type: Types.INTERNAL_USER_PERMISSIONS, payload: { userData } }),

}
